import {
  suggestionsPlugin,
  triggerCharacters,
} from '@chatwoot/prosemirror-schema/src/mentions/plugin';
import { getContentNode } from 'dashboard/helper/editorHelper';

const isCodePosition = ($position, marks = $position.marks()) =>
  $position.parent.type.spec.code ||
  marks.some(mark => mark.type === $position.doc.type.schema.marks.code);

export const useEditorMentions = ({ getView, disabled, onSuggestion }) => {
  let dismissedRange = null;
  const update = ({ range: nextRange, text, view }) => {
    if (
      !view.hasFocus() ||
      disabled() ||
      dismissedRange?.from === nextRange.from
    )
      return;
    onSuggestion({ active: true, query: text || '' });
  };
  const matchMention = triggerCharacters('@');
  const plugin = suggestionsPlugin({
    matcher: position =>
      isCodePosition(position) ? null : matchMention(position),
    suggestionClass: '',
    onEnter: update,
    onChange: update,
    onExit: () => {
      dismissedRange = null;
      onSuggestion({ active: false, query: '' });
    },
  });
  const dismiss = () => {
    const view = getView();
    dismissedRange = view && plugin.getState(view.state).range;
    onSuggestion({ active: false, query: '' });
  };
  const insert = content => {
    const view = getView();
    if (disabled() || !view) return;
    if (
      isCodePosition(
        view.state.selection.$from,
        view.state.storedMarks || undefined
      )
    )
      return;
    const current = plugin.getState(view.state);
    const selection = current.active ? current.range : view.state.selection;
    const { node } = getContentNode(view, 'mention', content, selection);
    // Dispatch through the editor so history, v-model and selections share one transaction.
    view.dispatch(
      view.state.tr
        .replaceWith(selection.from, selection.to, node)
        .insertText(' ')
    );
    view.focus();
    dismissedRange = null;
    onSuggestion({ active: false, query: '' });
  };
  const open = () => {
    if (disabled()) return;
    const view = getView();
    if (
      isCodePosition(
        view.state.selection.$from,
        view.state.storedMarks || undefined
      )
    )
      return;
    view.focus();
    dismissedRange = null;
    onSuggestion({
      active: true,
      query: plugin.getState(view.state).text || '',
    });
  };
  const reset = () => {
    dismissedRange = null;
    onSuggestion({ active: false, query: '' });
  };
  return { plugin, insert, dismiss, open, reset };
};
